import React, { useState, useEffect, useContext, Fragment } from "react"
import styled from "styled-components"
import { errorToastr } from "../../services/error-handler"
import { accessToken } from "../../interceptors/jwt-interceptor"
import { JourneyContext } from "../context/journeyContext"
import { ErrorContext } from "../context/errorContext";
import { SectionContext } from "../context/sectionContext";
import { DataLayerEventContext } from "../context/dataLayerEventContext";
import { withPrefix } from "gatsby"
import physicalMandate from "../../documents/SIM-physical-mandate.pdf"
import * as lookup from "../../../static/lookup.json"
import { fetchAllJourneyData, uploadDocument, aesEncryptData, saveApplication, paymentText, physicalMandateFormPDF, shareEnachLinkApi, getConfigurationsByType } from "../../services/apiservice"
import base64 from 'base-64'
import axios from "axios";
import Loader from "react-loader-spinner";
import Select from "react-select"
import { DataLayerIntegration } from "../services/helperFunctions"
import { getKeyFromValueLookup } from "../services/helperFunctions"

const SelectContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;
  min-width: 100%;
  max-width: 100%;

  & > .css-2b097c-container {
    margin-top: -17px;

    & div.css-1pahdxg-control {
      background: ${props =>
    props.channel === "A"
      ? "#ededed"
      : "#fff"} !important;
      background: var(--lumiq-bg) !important;
    }

    & > div {
      border-radius: 0;
      border: 1px solid #929292;
      padding: 1rem 0;
      padding-bottom: 0;
    }
    .css-1uccc91-singleValue {
      color: inherit;
      font-size: 1.2rem;
    }

    & div.css-yk16xz-control {
      background: ${props =>
    props.channel === "A"
      ? "#ededed"
      : "#fff"};
      background: var(--lumiq-bg);

      .css-1hb7zxy-IndicatorsContainer > div {
        padding: 0 !important;
        padding-right: 4px !important;
      }
    }
    .css-1gtu0rj-indicatorContainer {
      padding: 0 !important;
      padding-right: 4px !important;
    }
    & > div.css-26l3qy-menu {
      z-index: 500 !important;
      background: ${props =>
    props.channel === "A"
      ? "#ededed"
      : "#fff"};
      background: var(--lumiq-bg);
    }

    & > div {
      box-shadow: none !important;
      border: 1px solid #929292;
    }
    & .css-1okebmr-indicatorSeparator {
      background: transparent;
    }
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    padding: 2px 5px;
    background: var(--lumiq-bg);
    props.location?.state?.channel === "A"
      ? "#ededed"
      : props.location?.state?.channel === "B"
      ? "#fff"
      : props.location?.state?.channel === "C"
      ? "#fff"
      : "#fff"
    :
    "#ededed",
    padding: 2px 5px;
    z-index: 1;
    position: relative;
    display: inline-block;
    cursor: default;
  }
`

export default function ENachPhysicalMandate(props) {
    const [optionSelected, setOptionSelected] = useState("enach")
    const [isUploading, setIsUploading] = useState(false)
    const [fileName, setfileName] = useState()
    const [Upload, setUpload] = useState(false)
    const [journeyState, setJourneyState] = useContext(JourneyContext)
    const [sectionState, setSectionState] = useContext(SectionContext)
    const [showEnachShareLink,setShowEnachShareLink]=useState(false);
    const[errorState, setErrorState] = useContext(ErrorContext);
    const [dataLayerEventState, setDataLayerEventState] = useContext(DataLayerEventContext)
    const [responseDocument, setResponseDocument] = useState({
        _SIM_: {
            location: "",
            fileName: "",
            msg: "",
        }
    })

    const [isCanaraPosJourney, setIsCanaraPosJourney] = useState(false)
    const [showLoader, setShowLoader] = useState(true)

    const [downloadLink, setDownloadLink] = useState(physicalMandate)
    const [pdfData, setPdfData] = useState("") 
    const [journeyData, setJourneyData] = useState()
    const [enachLinkShared, setEnachLinkShared] = useState(false);

    let preferredDrawOptions = lookup.preferredDrawOptions[0]
    preferredDrawOptions = Object.entries(preferredDrawOptions).map(([key, val]) => ({
      value: key,
      label: val,
    }))

    useEffect(async () => {
        if (journeyState.journeyId) {
            let payload = {
                journeyId: journeyState.journeyId,
                // journeyId: "60f6e6f6e53b33e1e6299223",
            }

            let [journeyResult,bqpConfig]= await Promise.all([fetchAllJourneyData(payload),getConfigurationsByType({ type: "bqpPageChannels" })]);
            const channelKey=getKeyFromValueLookup("reverseChannelType",journeyState.channel)
            if(bqpConfig?.data?.[0].config.validChannels.find(e=>e===channelKey)) {
              setShowEnachShareLink(true)
            }
            setJourneyData(journeyResult)
            // if(journeyResult?.journeyType?.toLowerCase() === "canarapos" && journeyResult?.productDetails?.premiumFrequency === "12"){
            //   props.setCurrentPageIndex(prev => prev +1)
            //   setErrorState({})
            // }
            if(journeyResult?.journeyType?.toLowerCase() === "canarapos") {
                const pdfResponse = await physicalMandateFormPDF({
                  id: payload.journeyId,
                })
                if(pdfResponse?.status) {
                    // let decryptedPath = atob(pdfResponse?.pdfPath)
                    setDownloadLink("")
                    setPdfData(pdfResponse?.pdfPath)
                }
                setIsCanaraPosJourney(true)
                setOptionSelected("pMandate")
                setShowLoader(false)
            } else {
                setIsCanaraPosJourney(false)
                setShowLoader(false)
            }
            if (journeyResult.hasOwnProperty ("enachTransactions")) {
                if (journeyResult.enachTransactions.enachStatus === 'Success') {
                  let sectionIndex = props.currentSectionIndex
                  let pageIndex = props.currentPageIndex
                  let sectionIndexToFill = sectionIndex 
                  let pageIndexToFill = pageIndex + 1
                  let pageSectionIndexToFill =`${pageIndexToFill}${sectionIndexToFill}`
                  console.log(dataLayerEventState);
                  if(pageIndex === 2 && !dataLayerEventState.eventCalled[pageSectionIndexToFill]){
                      // dataLayerEventState.eventCalled[pageSectionIndexToFill] = true
                      setDataLayerEventState(prev=>{
                          return{
                              eventCalled:{
                                  ...prev.eventCalled,
                                  [pageSectionIndexToFill] : true
                              }
                          }
                      }) 
                  }
                  let journeyFormatData = props.applicationDataInJourneyFormat("","enach","enachSuccess")
                  DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "enachSuccess", journeyState) 
                  setJourneyState(prev => {
                      return {
                        ...prev,
                        enachSuccess: true,
                        isPhysicalMandateOpt: false
                      }
                    })
                    props.setCurrentPageIndex(prev => prev +1)
                    setErrorState({})
                    setSectionState(prev => {
                        // making section data empty to load new sectionData
                        return {
                          ...prev,
                          sectionId: null,
                          sectionFirstPass: null,
                          sectionData: {},
                        }
                      })
                    props.setCurrentSectionIndex(0)
                    setErrorState(prev=>{
                        return {
                          ...prev,
                          ['pincode']:"",
                          ['country']:""
                        }
                    })
                }
            } else if(journeyResult.isPhysicalMandateOpt && journeyResult.isPhysicalMandateOpt !== "false"){
              let journeyFormatData = props.applicationDataInJourneyFormat("" ,"enach", "enachFail")
              DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "enachFail", journeyState) 
              setJourneyState(prev => {
                  return {
                    ...prev,
                    enachSuccess: false,
                    isPhysicalMandateOpt: false
                  }
                })
                props.setCurrentPageIndex(prev => prev +1)
                setErrorState({})
                setSectionState(prev => {
                    // making section data empty to load new sectionData
                    return {
                      ...prev,
                      sectionId: null,
                      sectionFirstPass: null,
                      sectionData: {},
                    }
                  })
                props.setCurrentSectionIndex(0)
                setErrorState(prev=>{
                    return {
                      ...prev,
                      ['pincode']:"",
                      ['country']:""
                    }
                })
            }
        }else{
          setTimeout(() => {
            setShowLoader(false)
          },2500)
        }
    }, [journeyState.journeyId])

    useEffect(() => {
      if (journeyState.lienStatus){ // clear all errors
        setErrorState({})
        setErrorState({})
        if (journeyData?.productDetails.premiumFrequency === "SG"){ // skip enach page in case of SINGLE PREMIUM
          let sendPayload = {
            applicationData: journeyState.journeyData,
            journeyData: {
                _id: journeyState.journeyId,
                lastPage: props.currentPageIndex || 3,
                lastSection: props.currentSectionIndex || 0,
                applicationNo: journeyState.applicationNo,
                illustrationNumber: journeyState.illustrationNumber,
                proposalEntryId: journeyState.proposalEntryId,
                lastPageCode: props.pageId,
                lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
                planOption: journeyState.planOption,
                isPhysicalMandateOpt: false
            },
        }
          saveApplication(sendPayload).then(res => {
            console.log("save Application success response", res)
          }).catch(err => {
            console.log(err, "err in saveApplication")
          })
          props.setCurrentPageIndex(3)
          props.setCurrentSectionIndex(0)
        }
      }
    },[journeyData?.productDetails.premiumFrequency])

    const handleFileEnter = (event, inputId) => {

        if (event.key == 'Enter') {
            let el = document.getElementById(inputId)
            el.click()
        }

    }

    const uploadFile = async (e, field) => {
        if (isUploading) {
            return
        }
        let file = e?.target?.files[0]
        console.log(file, "file")
        if (!file) {
            return
        }

        //check for file size
        if (file.size > 5242880) {
            errorToastr("Maximum file sixe allowed is 5 Mb")
            return
        }

        //check for double extension
        let hasDoubleFormat = file.name?.split(".")?.length > 2
        if (hasDoubleFormat) {
            errorToastr("This file is not supported")
            return
        }

        //Check for file format
        let fileFormat = file.name?.split(".")?.[1]
        console.log(fileFormat, "fileFormat")
        if (!fileFormat || !(["pdf"]).includes(fileFormat)) {
            errorToastr("This file is not supported")
            return
        }

        //Check for null type
        if (file.size < 10) {
            errorToastr("Invalid file")
            return
        }

        //Check for mimetype
        if (!["application/pdf"].includes(file.type)) {
            errorToastr("File not supported")
            return
        }

        let formData = new FormData()
        if (e?.target?.files.length) {
        console.log(e.target.files, "dsskjjsf")
        setIsUploading(true)
        const file = e.target.files[0]
        let name = e.target.files?.[0]?.name || ""
        formData.append("doc", file)
        formData.append("sub", true)
        formData.append(
            "docPurpose", Date.now() + "-" +
            field + "." +
        name.split(".")[1]
        )
        formData.append(
            "uploadDocPurpose", field.split("_")[1]
        )
        console.log(formData)

            try {
                let payload = {
                    applicationNumber: journeyState.applicationNo,
                    option: "LA", 
                    module: "enach"
                  }
                const res = await uploadDocument(formData, payload) //journeyState.applicationNo
                if(res?.location){
                let location = res.location
                let encryptedToken = aesEncryptData({ accessToken: accessToken })
                let base64EncodedToken = base64.encode(encryptedToken)
                // console.log("base64EncodedToken", base64EncodedToken)
                let newLocation = `${location}?auth=${base64EncodedToken}`
                // console.log("newLocation", newLocation)
                res.location = newLocation
                console.log({ res })
                setUpload(true)
                setResponseDocument({
                    ...responseDocument,
                    [field]: res,
                })
                setIsUploading(false)
                setfileName(name)
              } else {
                errorToastr("File not supported")
                isUploading(false)
              }
            } catch (error) {
                setIsUploading(false)
            }
        }
    }

    const handleRadioChange = (e, option) => {
        setOptionSelected(option)
    }

    const handleEnachTrigger = async (e, option) => {
      let journeyFormatData = props.applicationDataInJourneyFormat("","enach","")
      DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "eNachRegister", journeyState) 
      setJourneyState(prev => {
        return {
          ...prev,
          enachSuccess: false,
          isPhysicalMandateOpt: false
        }
      })
        let sendPayload = {
            applicationData: journeyState.journeyData,
            journeyData: {
                _id: journeyState.journeyId,
                lastPage: props.currentPageIndex,
                lastSection: props.currentSectionIndex,
                applicationNo: journeyState.applicationNo,
                illustrationNumber: journeyState.illustrationNumber,
                proposalEntryId: journeyState.proposalEntryId,
                lastPageCode: props.pageId,
                lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
                planOption: journeyState.planOption,
            },
        }
        saveApplication(sendPayload).then(res => {
            console.log(res, "application response")
            const paymentPayload = {
                journeyId: journeyState.journeyId,
                module: "enach"
            }

            paymentText(paymentPayload)
                .then(res => {
                    console.log(res)
                    const redirectUrlPayload = {
                        applicationNumber: journeyState.applicationNo,
                        journeyId: journeyState.journeyId,
                        source: journeyState.channel,
                        module: "enach",
                    }
                    console.log(redirectUrlPayload, "redirectUrlPayload")
                    const data = JSON.stringify(redirectUrlPayload)
                    var encodedStringBtoA = btoa(data)
                    let productKey = lookup?.urlLookup?.[journeyState.journeyIdFromStrapi]
                    if(`${process.env.DEVELOPMENT}` === "Y"){
                    const url = `${process.env.ENACH_URL}?rd=${res.data.text}&redirectUrl=${process.env.GATSBY_URL}/enach-redirection/`;
                    window.open(url, "_self");
                    }
                    else if(`${process.env.DEVELOPMENT}` === "N"){
                        const url = `${process.env.ENACH_URL}?rd=${res.data.text}&redirectUrl=${process.env.GATSBY_URL}/${productKey}/enach-redirection/`;
                        window.open(url, "_self");
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        }).catch(err => {
            console.log(err, "err in saveApplication")
        })
    }

    const handlePhysicalMandateProcees = async (e) => {
      let sectionIndex = props.currentSectionIndex
      let pageIndex = props.currentPageIndex
      let sectionIndexToFill = sectionIndex 
      let pageIndexToFill = pageIndex + 1
      let pageSectionIndexToFill =`${pageIndexToFill}${sectionIndexToFill}`
      console.log(dataLayerEventState);
      if(pageIndex === 2 && !dataLayerEventState.eventCalled[pageSectionIndexToFill]){
          // dataLayerEventState.eventCalled[pageSectionIndexToFill] = true
          setDataLayerEventState(prev=>{
              return{
                  eventCalled:{
                      ...prev.eventCalled,
                      [pageSectionIndexToFill] : true
                  }
              }
          }) 
      }
      let journeyFormatData = props.applicationDataInJourneyFormat("","physicalMandate","")
      DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "physicalNachSuccess", journeyState)
      DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "physicalMandateProceed", journeyState)
      setJourneyState(prev => {
        return {
          ...prev,
          enachSuccess: true,
          isPhysicalMandateOpt: true
        }
      })
        console.log("responseDocument", responseDocument)
        if(fileName && responseDocument?.["_SIM_"]?.location){
            let sendPayload = {
                applicationData: journeyState.journeyData,
                journeyData: {
                    _id: journeyState.journeyId,
                    lastPage: props.currentPageIndex,
                    lastSection: props.currentSectionIndex,
                    applicationNo: journeyState.applicationNo,
                    illustrationNumber: journeyState.illustrationNumber,
                    proposalEntryId: journeyState.proposalEntryId,
                    lastPageCode: props.pageId,
                    lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
                    planOption: journeyState.planOption,
                    isPhysicalMandateOpt: true
                },
            }
            saveApplication(sendPayload).then(res => {
                props.setCurrentPageIndex(prev => prev +1)
                setErrorState({})
                setSectionState(prev => {
                    // making section data empty to load new sectionData
                    return {
                      ...prev,
                      sectionId: null,
                      sectionFirstPass: null,
                      sectionData: {},
                    }
                  })
                props.setCurrentSectionIndex(0)
                setErrorState(prev=>{
                  return {
                    ...prev,
                    ['pincode']:"",
                    ['country']:"",
                  }
                })
                setErrorState(prev=>{
                  return {
                    ...prev,
                    ['pincode']:"",
                    ['country']:"",
                  }
                })
            })
        }
    }

    async function downloadLinkOfPdf(Base64Pdf) {
      const fileName = `${journeyState.applicationNo}_SIM-physical-mandate_Form.pdf`
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        var byteCharacters = atob(Base64Pdf)
        var byteNumbers = new Array(byteCharacters.length)
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        var byteArray = new Uint8Array(byteNumbers)
        var blob = new Blob([byteArray], { type: "application/pdf" })
        window.navigator.msSaveOrOpenBlob(blob, fileName)
        return
      }
      // For Other Browsers
      const linkSource = "data:application/pdf;base64," + Base64Pdf
      const link = document.createElement("a")
      link.href = linkSource
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      link.remove()
  
      window.addEventListener(
        "focus",
        function () {
          URL.revokeObjectURL(link.href)
        },
        { once: true }
      )
    }

    const downloadPdf = async (ev) => {
      ev.preventDefault()
      downloadLinkOfPdf(pdfData)
    }

    function getKeyByValue(object, value) {
      return object.find(key => key.value == value)
    }


    const handleEnterSkip = (event) => {
      if (event?.key == 'Enter') {
        handleSkip();
      }
    }
    const handleSkip = (e) => {
      e.preventDefault()
      let sendPayload = {
        applicationData: journeyState.journeyData,
        journeyData: {
            _id: journeyState.journeyId,
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex,
            applicationNo: journeyState.applicationNo,
            illustrationNumber: journeyState.illustrationNumber,
            proposalEntryId: journeyState.proposalEntryId,
            lastPageCode: props.pageId,
            lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
            planOption: journeyState.planOption,
            isPhysicalMandateOpt: false
        },
    }
    saveApplication(sendPayload).then(res => {
      proceed()
    })
      return 
    }

    const proceed=()=>{
       props.setCurrentPageIndex(prev => prev + 1)  //this moves to next page
        setSectionState(prev => {
            // making section data empty to load new sectionData
            return {
              ...prev,
              sectionId: null,
              sectionFirstPass: null,
              sectionData: {},
            }
          })
        props.setCurrentSectionIndex(0);
    }

    const handleChange = async (e) => {
      console.log(sectionState.sectionData);
      setSectionState((prev) => {
        return{
          ...prev,
          sectionData: {
            ...prev.sectionData,
            "preferredDrawOptions" : e.value,
          },
        }
      })
      console.log(sectionState.sectionData);
      if(journeyData?.journeyType?.toLowerCase() === "canarapos") {
        const pdfResponse = await physicalMandateFormPDF({
          id: journeyState.journeyId,
          preferredDrawOptions: e.value
        })
        if(pdfResponse?.status) {
            // let decryptedPath = atob(pdfResponse?.pdfPath)
            setDownloadLink("")
            setPdfData(pdfResponse?.pdfPath)
        }
        setIsCanaraPosJourney(true)
        setOptionSelected("pMandate")
        setShowLoader(false)
    }
    }

    const callDataLayer = (e) => {
      let journeyFormatData = props.applicationDataInJourneyFormat("","enach","enachSuccess")
      DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "enachLinkDownload", journeyState) 
  }
  const callEnachShareLinkApi = () => {
    try {
      const payload = {
        "journeyId": journeyData?._id
      };
      shareEnachLinkApi(payload).then((response) => {
        if (response?.status) {
          console.log("Link Share successfully:", response.message);
          setEnachLinkShared(true);
        } else {
          console.error("Error in updating UserTracker:", response?.message);
        }
      })
        .catch((error) => {
          console.error("Error in updateUserTrackerDetails API call:", error);
        })
    } catch (error) {
      console.error("Error calling eNACH API:", error);
    }
  };


    return (
      <>
      {showLoader?<div
      style={{
        height: "100vh",
        width: "100%",
        background: "#80808061",
        position: "fixed",
        zIndex: showLoader ? "999999999999" : "-999999999999",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Loader
        type="Grid"
        color="var(--lumiq-secondary2)"
        height={100}
        width={100}
        visible={showLoader}
      />
    </div>:null}
        <style>
          {`
        .display-option {
            font-style: italic;
        }
        .condition-option {
            background-color: var(--lumiq-secondary);
            padding: 5px 15px;
            font-size: 18px;
            color: #fff;
        }
        .choose-design{
            background-color: var(--lumiq-tertiary);
            padding: 11px 15px;
            margin-top: 11px
            font-size: 18px;
            color: #fff;
            border-radius: 0.5rem;
        }
        .button-option {
            margin-top: 0px;
            display:flex;
            justify-content: center;
        }
        .enachSkipCanaraPos {
          display: flex;
          justify-content: center;
        }
        .eNach .container {
          padding-left: 35px
        }
        .enach-share-group {
            display:flex;
            align-items:center; 
            justify-content:space-between;
        }
        .eNach-button {
            background-color: var(--lumiq-tertiary);
            padding: 0.5rem 1rem;
            font-size: 18px;
            color: #fff;
            border: none;
            margin: 0px 10px;
            margin-right: 0px;
            transition: 0.5s;
            border-radius: 0.5rem;
            margin-bottom:15px;
        }
        @media (max-width: 767px){
         .enach-share-group {
            flex-direction:column;
            align-items:start;
         }

            .button-option-1 {
                margin-left: 3px;
                display: inline-flex;
            }
            .file{
                padding: 5px;
              }
              .form-group {
                  margin-bottom: 4px;
              }
            
          }
          .button-option-1 {
            margin-left: 3px;
            display: inline-flex; 
        }
        .form-content {
            font-size: 19px; 
        }
        .file{
          padding: 12px;
          display: inline-block;
        }
        .file1{
            padding: 5px;
            display: inline-block;
          }
        .form-group{
            font-size: 15px; 
        }
        .btn-disable{
          opacity:.5;
          pointer-events:none
        }
        .filename{
            padding: 1px 35px 2px;
        }
        .upload-img1 {
            float: right;
            text-align: left;
            position: absolute;
            margin-top: -10px;
        }
        .upload-img1 img {
            width: 35%;
          }
        `}
        </style>
        <div className="landing-page1-design">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="iselect-box-design">
                  <div className="heading-design">
                    <div
                      className="iselect-padding left-side-head "
                      style={{ width: "65% !important" }}
                    >
                      <h1 className="iselect-heading">
                        {isCanaraPosJourney
                          ? "Physical Mandate"
                          : "e-Nach/Physical Mandate"}
                      </h1>
                      <p style={{ paddingLeft: "1rem", marginTop: "1rem" }}>
                        Canara HSBC Life Insurance Company Limited
                      </p>
                    </div>
                    <div className="app-quatation nri-mt-space hidden-desktop-screen">
                      <div className="application-design-number">
                        e-Application Number: {journeyState.applicationNo}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="eNach">
          <div className="container">
            <div className="enach-share-group">
              <p className="display-option">
                *Activate auto-debit facility via net-banking
              </p>
              {optionSelected === "pMandate" && (
                <div className="button-option">
                  <button className="eNach-button" onClick={() =>{callEnachShareLinkApi()}}>
                    SHARE e-NACH LINK
                  </button>
                </div>
              )}
            </div>
            {!isCanaraPosJourney && <div className="box-container">
              <p className="condition-option">
                Do you wish to opt for &nbsp;
                    <input
                      type="radio"
                      name="option-data"
                      value="enach"
                      checked={optionSelected === "enach" ? true : false}
                      onChange={e => handleRadioChange(e, "enach")}
                    />{" "}
                    e-Nach &nbsp;
                {props.channel !== "PBP" && <>
                <input
                  type="radio"
                  name="option-data"
                  value="mandate"
                  checked={optionSelected === "pMandate" ? true : false}
                  onChange={e => handleRadioChange(e, "pMandate")}
                />{" "}
                Physical Mandate
                </>
                }
              </p>
            </div>}
            {optionSelected === "enach" && (
              <div className="d-flex justify-content-center gap-5">
              <div className="button-option">
                <button className="eNach-button" onClick={handleEnachTrigger}>
                  e-Nach Register
                </button>
              </div>
              { journeyData?.productDetails?.premiumFrequency !== "01" && <div className="button-option">
                <button className="eNach-button" onClick={handleSkip}>
                  Skip e-Nach registeration
                </button>
              </div>}
              </div>
            )}
            {optionSelected === "pMandate" && (
              <div className="physical-mandate">
                <p className="display-option">
                  *Activate auto-debit facility by providing account details
                  NACH PDF, Please note: Upload NACH PDF in document upload
                  section
                </p>
                <br />
                <div className="file-upload">
                  
                <div className="col-lg-4 col-md-6 col-sm-4 col-xs-4" style={{paddingRight:"0px"}}>
                {(isCanaraPosJourney && (journeyData?.productDetails?.premiumFrequency !== "01")) && 
                  <div>
                    <SelectContainer>
                      <label >Preferred Draw Date</label>
                      <Select
                        options={preferredDrawOptions}
                        name="Select"
                        key="Select"
                        id="InputSelect"
                        required={true}
                        tabIndex={-1}
                        // onChange={e =>
                        //   handleChange("title", {
                        //     target: { value: e.value },
                        //   })
                        // }
                        value={
                          getKeyByValue(
                            preferredDrawOptions,
                            sectionState.sectionData["preferredDrawOptions"]
                          )
                        }
                        onChange={(e)=>handleChange(e)}
                      ></Select>
                      {/* <span className="input-error">
                        {(showLocalError["preferredDrawOptions"] || showAllError) && errorState.errorData?.["preferredDrawOptions"]}
                      </span> */}
                    </SelectContainer>
                  </div>
                  }
                  <div>
                  {isCanaraPosJourney ?
                  <a href={downloadLink} download onClick={downloadPdf}>
                    <p className="form-content">
                      Click here to download eNach form online
                    </p>
                  </a>
                  : 
                  <a href={downloadLink} download  onClick={()=>{
                    let journeyFormatData = props.applicationDataInJourneyFormat("" ,"enach", "enachLinkDownload")
                    DataLayerIntegration(journeyFormatData, "", "eNach-physicalMandate", "enachLinkDownload", journeyState)
        }}>
                  <p className="form-content">
                    Click here to download eNach form online
                  </p>
                </a>
                }
                    </div>
                </div>

                  <p className="form-group">Physical Form</p>
                  <br />
                  <div className="button-option-1">
                    <div className={isUploading ? "btn-disable" : ""}>
                      <label
                        disabled={isUploading}
                        className="choose-design"
                        onKeyPress={event => handleFileEnter(event, "file1")}
                      >
                        {" "}
                        Choose File
                        <input
                          type="file"
                          id="file1"
                          name="physical-mandate"
                          onInput={e => uploadFile(e, "_SIM_")}
                          accept="application/pdf"
                          // required
                        />
                      </label>
                    </div>
                    &nbsp;
                    {!Upload && <div className="file1">{"No File Chosen"}</div>}
                    {Upload && (
                      <div className="file">
                        <div className="upload-img1 icon-img5">
                          {" "}
                          <img src={withPrefix("/images/upload51.png")} />
                        </div>
                        <div className="filename">{fileName}</div>
                      </div>
                    )}
                  </div>
                  <div className="enachSkipCanaraPos" >
                    {(isCanaraPosJourney && journeyData?.productDetails?.premiumFrequency !== "01") || enachLinkShared &&
                      <div className="provider submit-btn cen" tabIndex="0"
                        onKeyPress={(e) => handleEnterSkip(e)}>
                        {" "}
                        <a
                          aria-hidden="true"
                          onClick={handleSkip}
                          style={{ padding: "14px 30px" }}
                        >
                          {" "}
                          Skip{" "}
                        </a>{" "}
                      </div>
                      // <div className="button-option">
                      //   <button
                      //     className="eNach-button"
                      //     onClick={(e)=>handleSkip(e)}
                      //   >
                      //     Skip
                      //   </button>
                      // </div>
                    }
                    <div className="button-option">
                      <button
                        className="eNach-button"
                        onClick={handlePhysicalMandateProcees}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            
          </div>
        </div>
        {/* <!--Footer-design-->  */}
      </>
    )

}